import script from "./NewChronologyDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./NewChronologyDetail.vue?vue&type=script&setup=true&lang=js"

import "./NewChronologyDetail.vue?vue&type=style&index=0&id=d5d33f4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5d33f4a"]])

export default __exports__